var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "items": Object.values(_vm.RepairStatusEnum),
      "label": _vm.$t('objects.report.repair.status') + ' *',
      "outlined": "",
      "rules": _vm.required
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(_vm.$t("enums.RepairStatusEnum." + item)) + " ")];
      }
    }, {
      key: "selection",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm.$t("enums.RepairStatusEnum." + item)) + " ")];
      }
    }]),
    model: {
      value: _vm.value.status,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "status", $$v);
      },
      expression: "value.status"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.report.repair.startDate'),
      "outlined": "",
      "type": "date",
      "clearable": ""
    },
    model: {
      value: _vm.value.startDateFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "startDateFormable", $$v);
      },
      expression: "value.startDateFormable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.report.repair.endDate'),
      "outlined": "",
      "type": "date",
      "clearable": ""
    },
    model: {
      value: _vm.value.endDateFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "endDateFormable", $$v);
      },
      expression: "value.endDateFormable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": _vm.$t('objects.report.repair.isRentalProvided'),
      "outlined": ""
    },
    model: {
      value: _vm.value.isRentalProvided,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "isRentalProvided", $$v);
      },
      expression: "value.isRentalProvided"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$t('objects.report.repair.notes'),
      "outlined": ""
    },
    model: {
      value: _vm.value.notes,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "notes", $$v);
      },
      expression: "value.notes"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }